import { render, staticRenderFns } from "./MainRent.vue?vue&type=template&id=1d25842b&scoped=true&"
import script from "./MainRent.vue?vue&type=script&lang=js&"
export * from "./MainRent.vue?vue&type=script&lang=js&"
import style0 from "./MainRent.vue?vue&type=style&index=0&id=1d25842b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25842b",
  null
  
)

export default component.exports